import React from 'react';
import Pagination from 'react-js-pagination';
import { IBox, Title, Content, Icon, Row, Column, Search, Button } from '../inspinia';
import { DEFAULT_PAGE_RANGE, MESSAGE_ERROR, AUTH_ERROR, AUTH_HEADER, API_BASE_URL, API_CAMPAIGN_URL ,TOASTER_ERROR, TOASTER_SUCCESS } from '../../helpers/constants';

import './style.css';
import { getToken, isAuthenticated } from '../../store/auth';
import { callApi } from '../../helpers/methods';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

export default class TemplateList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            obj: [],
            page: 0,
            list:
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, results: undefined,
                results: []
            },
            filter: props.filter || '',
            recarregar: this.props.recarregar,
            useExternalControl: !!props.templates,
            alerta: withReactContent(Swal)
        }

        
        this.alerta = withReactContent(Swal);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleBuscarInput = this.handleBuscarInput.bind(this);
        this.handleBuscarClick = this.handleBuscarClick.bind(this);
        this.onClickExcluir = this.onClickExcluir.bind(this);
        this.excluir = this.excluir.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.useExternalControl && this.props.filter !== prevProps.filter) {
            this.setState({ filter: this.props.filter || '' });
        }

        if (
            !this.state.useExternalControl &&
            (!this.state.list.results || this.state.recarregar)
        ) {
            this.state.recarregar = false;
            this.loadListaTemplates(this.state.page);
        }
    }

    loadListaTemplates(pageNumber, filterParam) {
        let listaTemplates = this.props.templates;

        if (filterParam) {
            listaTemplates = listaTemplates.filter(t => t.nome.toUpperCase().includes(filterParam.toUpperCase()));
        }

        let page = pageNumber === undefined || pageNumber === 0 ? 0 : pageNumber - 1;
        let limit = 10;
        let slice1 = page * limit;
        let slice2 = limit * (page + 1);

        this.setState({
            ...this.state,
            list: {
                ...this.state.list,
                results: listaTemplates.slice(slice1, slice2),
                pageSize: limit,
                rowCount: listaTemplates.length,
                currentPage: this.state.page
            }
        });
    }

    async excluir(index, id) {
        if (!isAuthenticated()) {
          throw MESSAGE_ERROR(AUTH_ERROR);
        }
        const token = AUTH_HEADER(getToken());
        const url = `${API_CAMPAIGN_URL}/template/${id}`;
    
        try {
          const res = await fetch(url, { method: 'DELETE', headers: { Authorization: token } });
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          // atualiza localmente
          this.setState(prev => ({
            list: {
              ...prev.list,
              results: prev.list.results.filter((_, i) => i !== index)
            }
          }));
          return true;
        } catch (err) {
          this.alerta.showValidationMessage(`Falha ao excluir`);
          return false;
        }
      }
    
      async onClickExcluir(index, idTemplate) {
        const result = await this.alerta.fire({
          title: 'Deseja realmente excluir?',
          text: 'A ação é irreversível.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, excluir',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#47A789',
          cancelButtonColor: '#ED5358',
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
          preConfirm: () => this.excluir(index, idTemplate)
        });
    
        if (result.isConfirmed && result.value) {
            this.alerta.fire({
                title: 'Sucesso!',
                text: 'Template excluído.',
                icon: 'success',
                confirmButtonText: 'OK',
                confirmButtonColor: '#47A789' 
              });
          this.props.onReloadTemplates?.();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.alerta.fire({
            title: 'Cancelado',
            text: 'Não foi possível excluir o template.',
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#ED5358'
          });
        }
      }

    handleBuscarClick() {
        const q = (this.state.filter ?? '').trim();

        if (this.state.useExternalControl) {
            this.props.onSearch?.(q);
        } else {
            this.setState({ page: 1 }, () => this.loadListaTemplates(1, q));
        }
    }
    
    handlePageChange(pageNumber) {
        if (this.state.useExternalControl) {
            this.props.onPageChange?.(pageNumber);
        } else {
            this.setState({ page: pageNumber }, () => this.loadListaTemplates(pageNumber, this.state.filter));
        }
    }

    handleBuscarInput(e) {
        const raw = e.target.value ?? '';
        const trimmed = raw.trim();

        this.setState({ filter: raw }, () => {
            if (trimmed === '') {
                if (this.state.useExternalControl) {
                    this.props.onSearch?.('');
                } else {
                    this.setState({ page: 1 }, () => this.loadListaTemplates(1, ''));
                }
            }
        });
    }

    render() {

        const templates = this.state.useExternalControl
        ? this.props.templates || []
        : this.state.list.results || [];

        let html = "";

        if (!templates || templates.length === 0) {
        html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        } else {
            html = templates.map((template, index) =>
                <li className="itemListaTemplates" id={template.id} key={template.id}>
                    <div>
                        <span>{template.nome}</span>
                    </div>
                    <div>
                        <div className="text-center">
                            <a onClick={() => {
                            if (this.props.customEditAction) {
                            this.props.customEditAction(template.id);
                            } else {
                            this.props.onClick?.(this.props.status, template.id);
                            }
                            }}>
                            <Icon name="fa-edit" className="mx-1 text-info" />
                            </a>
                            <a onClick={() => this.onClickExcluir(index, template.id)}>
                                <Icon name="fa-times" className="mx-1 text-muted" />
                            </a>
                        </div>
                    </div>
                </li>
            );
        }

        return (
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Templates</h3>
                            </Title>

                            <Content>
                                {/* MENU DE OPÇÕES */}
                                <div hidden={!this.state.useExternalControl && this.state.list.results === undefined}>
                                    <Row className="m-0 mb-3">
                                        <Column size="9" className="p-0 mx-auto container">

                                            <Button onClick={() => {
                                                if (this.props.customNewAction) {
                                                    this.props.customNewAction(); // redireciona na sua nova tela
                                                } else if (this.props.novoTemplate) {
                                                    this.props.novoTemplate(); // mantém funcionalidade anterior
                                                }
                                            }}>
                                                <Icon name="fa-plus" /> Criar novo template
                                            </Button>

                                        </Column>

                                        <Column size="3" className="p-0 mx-auto container">

                                            <Search onChange={this.handleBuscarInput} onClick={this.handleBuscarClick} value={this.state.filter} />

                                        </Column>

                                    </Row>
                                </div>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        <ul className="listaTemplates">{html}</ul>
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>
                    </Column>
                </Row>

                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">

                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={DEFAULT_PAGE_RANGE}
                                        activePage={this.state.useExternalControl ? this.props.currentPage : this.state.page}
                                        itemsCountPerPage={this.state.useExternalControl ? this.props.pageSize : this.state.list.pageSize}
                                        totalItemsCount={this.state.useExternalControl ? this.props.totalElements : this.state.list.rowCount}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>
                        </Row>
                    </Column>
                </Row>
            </div>
        )
    }
}
